import { create } from "zustand";
import type { IVendor } from "../types/models/vendor.modals.types";

interface IVendorStore {
  data: IVendor | null;
  setData: (data: IVendor | null) => void;
}

const useVendorStore = create<IVendorStore>((set) => ({
    data: {} as IVendor,
    setData: (data: IVendor | null) => set(() => ({ data })),
}));

export default useVendorStore;
